<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <ValidationObserver v-slot="{ passed, failed }">
          <form>
            <md-card class="p-25">
              <md-card-content>
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <label>نوع العملية</label>

                      <md-select v-model="PromotionType">
                        <md-option value="Promotion">ترقية</md-option>
                        <md-option value="Settlement">تسوية</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <model-list-select
                      class="input-must-rtl"
                      :list="employees"
                      v-model="EmployeeId"
                      option-value="key"
                      option-text="value"
                      placeholder="الموظف"
                    >
                    </model-list-select>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                  >
                    <md-datepicker :md-open-on-focus="false" v-model="date">
                      <label class="mr-28">تاريخ الترقية أو العلاوة</label>
                    </md-datepicker>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>رقم القرار</label>
                      <md-input v-model="DecisionNumber"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>الدرجة بعد الترقية /التسوية</label>
                      <md-input
                        type="number"
                        v-model="GradeAfterSettlement"
                      ></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field>
                      <label>سبب الدرجة الحالية</label>
                      <md-select v-model="ReasonForCurrentGrade">
                        <md-option value="1">ترقية اعتيادية</md-option>
                        <md-option value="2">ترقية تشجيعية</md-option>
                        <md-option value="3">تسوية</md-option>
                        <md-option value="4">حكم محكمة</md-option>
                        <md-option value="5">درجة المؤهل</md-option>
                      </md-select>
                    </md-field>
                  </div>

                  <div
                    v-if="PromotionType == 'Settlement' || PromotionType == ''"
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>العلاوة بعد التسوية</label>
                      <md-input
                        type="number"
                        v-model="BonusAfterSettlement"
                      ></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>مصدر القرار</label>
                      <md-input v-model="PromotionOriginator"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                  >
                    <md-datepicker
                      :md-open-on-focus="false"
                      v-model="decisionDate"
                    >
                      <label class="mr-28"> تاريخ صدور القرار </label>
                    </md-datepicker>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>الدرجة الإدارية الحالية</label>
                      <md-input disabled v-model="degree"></md-input>
                    </md-field>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <label>العلاوة الإدارية الحالية</label>
                      <md-input disabled v-model="bonuse"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-100 mtb-20 center-content">
                    <md-button @click="Save" class="md-success btn_nanosoft"
                      >حفظ</md-button
                    >
                    <md-button @click="clear" class="md-info btn_nanosoft"
                      >جديد</md-button
                    >
                    <md-button class="md-info btn_nanosoft">طباعة</md-button>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">البحث</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout mt-25">
            <div class="md-layout-item md-size-30 md-small-size-100 ml-15">
              <model-list-select
                class="input-must-rtl"
                :list="employees"
                v-model="EmployeeSearch"
                option-value="key"
                option-text="value"
                placeholder="الموظف"
              >
              </model-list-select>
            </div>

            <div class="md-layout-item md-size-20 md-small-size-100 ml-15">
              <md-datepicker :md-open-on-focus="false" v-model="DateFrom">
                <label class="mr-28">من تاريخ</label>
              </md-datepicker>
            </div>

            <div class="md-layout-item md-size-20 md-small-size-100 ml-15">
              <md-datepicker :md-open-on-focus="false" v-model="DateTo">
                <label class="mr-28">الى تاريخ</label>
              </md-datepicker>
            </div>

            <div
              class="md-layout-item md-size-20 md-small-size-100 center-content ml-15"
            >
              <md-button @click="Search" class="md-success btn_nanosoft"
                >بحث</md-button
              >
            </div>
          </div>

          <div class="md-layout flex-content-left">
            <div class="md-layout-item mt-25 md-size-15">
              <md-table>
                <md-table-toolbar>
                  <md-field>
                    <label for="pages">عدد النتائج</label>
                    <md-select v-model="pagination.perPage" name="pages">
                      <md-option
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                        >{{ item }}</md-option
                      >
                    </md-select>
                  </md-field>
                </md-table-toolbar>
              </md-table>
            </div>
          </div>

          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover mt-25"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell class="w-200" md-label="الإسم">{{
                item.employeeName
              }}</md-table-cell>

              <md-table-cell md-label="رقم الموظف">{{
                item.employeeJobNumber
              }}</md-table-cell>
              <md-table-cell class="date" md-label="التاريخ">{{
                convert(item.date)
              }}</md-table-cell>
              <md-table-cell md-label="رقم القرار">{{
                item.decisionNumber
              }}</md-table-cell>

              <md-table-cell
                v-if="item.promotionType == '1'"
                md-label="نوع العملية"
              >
                ترقية
              </md-table-cell>

              <md-table-cell
                v-if="item.promotionType == '2'"
                md-label="نوع العملية"
              >
                تسوية
              </md-table-cell>

              <md-table-cell
                v-if="item.promotionType == ''"
                md-label="نوع العملية"
              ></md-table-cell>

              <md-table-cell md-label="الدرجة قبل التسوية">{{
                item.gradeBeforeSettlement
              }}</md-table-cell>

              <md-table-cell md-label="العلاوة قبل التسوية">{{
                item.bonusBeforeSettlement
              }}</md-table-cell>

              <md-table-cell md-label="الدرجة بعد التسوية">{{
                item.gradeAfterSettlement
              }}</md-table-cell>

              <md-table-cell md-label="العلاوة بعد التسوية">{{
                item.bonusAfterSettlement
              }}</md-table-cell>

              <md-table-cell md-label>
                <div class="md-just-icon md-info md-simple"></div>
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="handleEdit(item)"
                >
                  <md-icon>dvr</md-icon>
                </md-button>
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                >
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <!-- <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                  >
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">{{ item }}</div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div> -->
        </md-card-content>

        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>

        <!-- <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination class="pagination-no-border pagination-success" v-model="pagination.currentPage"
            :per-page="pagination.perPage" :total="total"></pagination>
        </md-card-actions> -->
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from "../../../../components/service/HTTP.js";
import { Pagination } from "@/components";

import moment from "moment";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
// import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, numeric, regex, confirmed } from "vee-validate/dist/rules";
import env from "../../../../../env";
extend("required", required);
extend("numeric", numeric);
extend("regex", regex);
extend("confirmed", confirmed);
export default {
  async created() {
    await this.init();
  },
  components: {
    Pagination,
    ModelListSelect,

    // SlideYDownTransition
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      return this.tableData;
      // if (this.searchedData.length > 0) {
      //   result = this.searchedData;
      // }
      // return result.slice(this.from, this.to);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
  },
  data() {
    return {
      degree: 0,
      bonuse: 0,
      PromotionType: "",
      PromotionOriginator: "",
      decisionDate: null,
      EmployeeId: "",
      date: null,
      DateFrom: null,
      DateTo: null,
      DecisionNumber: "",
      GradeAfterSettlement: "",
      BonusAfterSettlement: null,
      ReasonForCurrentGrade: null,

      EmployeeSearch: "",
      employees: [],

      errorMessage: "",

      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["Titel", "Severity", "Status"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      currentSort: "Titel",
      currentSortOrder: "asc",
    };
  },

  watch: {
    "pagination.perPage"() {
      this.Search();
    },
    "pagination.currentPage"() {
      this.Search();
    },
    async EmployeeId() {
      try {
        if (this.EmployeeId != "") {
          let T = localStorage.getItem("Nannotoken");
          let token = atob(T);
          let result = await axios.get(
            `${env.HR()}/api/hr/Employees/getDegreeAndBonuse/${
              this.EmployeeId
            }`,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
          this.degree = result.data.data.degree;
          this.bonuse = result.data.data.bonuse;
        }
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    },
  },

  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },

    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
    async Save() {
      try {
        let T = localStorage.getItem("Nannotoken");

        if (!this.EmployeeId) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء اختيار الموظف "
          );
        }

        if (!this.date) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال التاريخ  "
          );
        }

        if (!this.DecisionNumber) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال رقم القرار "
          );
        }

        if (!this.BonusAfterSettlement && this.PromotionType == "Settlement") {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال العلاوة بعد التسوية "
          );
        }

        if (!this.GradeAfterSettlement && this.PromotionType == "Settlement") {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال الدرجة بعد التسوية "
          );
        }

        if (!this.GradeAfterSettlement && this.PromotionType == "Promotion") {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال الدرجة بعد الترقية "
          );
        }

        let token = atob(T);

        let schema = {
          EmployeeId: this.EmployeeId,
          Date: moment(this.date).format("YYYY-MM-DD[T]hh:mm:ss"),
          DecisionNumber: this.DecisionNumber,
          GradeAfterSettlement: parseInt(this.GradeAfterSettlement),
          ReasonForCurrentGrade: parseInt(this.ReasonForCurrentGrade),
          BonusAfterSettlement:
            this.BonusAfterSettlement == null
              ? 0
              : parseInt(this.BonusAfterSettlement),
          PromotionOriginator: this.PromotionOriginator,
          decisionDate:
            this.decisionDate == null
              ? null
              : moment(this.decisionDate).format("YYYY-MM-DD[T]hh:mm:ss"),
          PromotionType: this.PromotionType == "Promotion" ? 1 : 2,
        };

        let result = await axios.post(
          `${env.HR()}/api/situation-settlements`,
          schema,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );

        this.init();
        this.clear();
        return this.notifyVue("top", "center", "success", " تم الحفظ بنجاح ");
      } catch (error) {
        this.message(error);
      }
    },

    async init() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.get(
          `${env.HR()}/api/situation-settlements/preload`,
          {
            headers: { Authorization: "Bearer " + token },
          }
        );

        this.employees = result.data.data.employees;
        this.tableData = result.data.data.situationSettlements.results;
      } catch (error) {
        this.message(error);
      }
    },

    clear() {
      (this.EmployeeId = ""),
        (this.date = null),
        (this.DecisionNumber = ""),
        (this.GradeAfterSettlement = ""),
        (this.ReasonForCurrentGrade = null);
      this.BonusAfterSettlement = null;
      this.decisionDate = null;
      (this.PromotionType = ""), (this.PromotionOriginator = "");
    },

    async Search() {
      try {
        this.tableData = [];
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.get(
          `${env.HR()}/api/situation-settlements/filter?EmployeeId=${
            this.EmployeeSearch
          }&DateFrom=${moment(this.DateFrom).format("YYYY/MM/DD")}&DateTo=${
            this.DateTo
          }&PageSize=${this.pagination.perPage}&currentPage=${
            this.pagination.currentPage
          }`,

          {
            headers: { Authorization: "Bearer " + token },
          }
        );

        this.tableData = result.data.data.results;
        this.pagination.total = result.data.data.total;
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          error.response.data.errors[Object.keys(error.response.data.errors)][0]
        );
      }
    },

    handleLike(item) {
      Swal.fire({
        title: `You liked ${item.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "md-button md-success",
      });
    },

    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },

    message(error) {
      if (error.response.data.message != undefined) {
        this.errorMessage = error.response.data.message;
      } else {
        this.errorMessage =
          error.response.data.errors[
            Object.keys(error.response.data.errors)[0]
          ][0];
      }

      return this.notifyVue("top", "center", "danger", this.errorMessage);
    },

    handleDelete(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);
            let result = await axios.delete(
              `${env.HR()}/api/situation-settlements/${item.id}`,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );
            this.deleteRow(item);
            return this.notifyVue(
              "top",
              "center",
              "success",
              "تم الحذف بنجاح "
            );
          } catch (error) {
            let result =
              error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ];
            return this.notifyVue("top", "center", "danger", result[0]);
          }
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },

    handleEdit(item) {
      const offsetTop = document.getElementById("#content");
      scroll({
        top: offsetTop,
        behavior: "smooth",
      });

      this.EmployeeId = item.employeeId;
      if (item.date !== null) {
        this.date = new Date(item.date);
      }
      (this.DecisionNumber = item.decisionNumber),
        (this.GradeAfterSettlement = item.gradeAfterSettlement),
        (this.ReasonForCurrentGrade = item.reasonForCurrentGrade),
        (this.BonusAfterSettlement = item.bonusAfterSettlement);

      if (item.promotionType == "1") {
        this.PromotionType = "Promotion";
      }
      if (item.promotionType == "2") {
        this.PromotionType = "Settlement";
      }

      this.PromotionOriginator = item.promotionOriginator;
      this.decisionDate = new Date(item.decisionDate);
    },
  },
};
</script>

<style scoped>
.mt-37 {
  margin-top: 37px;
}

.mt-12 {
  margin-top: 12px;
}

.fullname .md-table-cell-container {
  width: 185px !important;
}

.paginated-table .fullname {
  width: 185px !important;
  display: flex;
  padding-top: 0px !important;
}

.paginated-table .date {
  width: 85px !important;
  display: flex;
  padding-top: 20px !important;
}
</style>
